module.exports = __webpack_public_path__ + "static/img/viral_06.bfeb111b.jpg";